import React from "react";
import CustomDialog from "../customDialog/CustomDialog";
import {
  PulseButton,
  PulsePopupContainerSize,
} from "@pulselabs-ai/shared-fe-ui";
import "./SDKDocsDialog.scss";

interface SDKDocsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SDKDocsDialog: React.FC<SDKDocsDialogProps> = ({ isOpen, onClose }) => {
  return (
    <CustomDialog
      isOpen={isOpen}
      onClose={onClose}
      containerSize={PulsePopupContainerSize.SMALL}
      roundedCorners={true}
    >
      <div className="docs-dialog">
        <h2>SDK Documentation</h2>
        <div className="docs-links">
          <PulseButton
            onClick={() =>
              window.open(
                "https://pulselabs.gitbook.io/pulse-flightrecorder-docs/sdk-documentation/pulse-labs-flightrecorder-documentation/ios/create-custom-triggers",
                "_blank",
              )
            }
          >
            iOS Documentation
          </PulseButton>
          <PulseButton
            onClick={() =>
              window.open(
                "https://pulselabs.gitbook.io/pulse-flightrecorder-docs/sdk-documentation/pulse-labs-flightrecorder-documentation/android/create-custom-triggers",
                "_blank",
              )
            }
          >
            Android Documentation
          </PulseButton>
        </div>
      </div>
    </CustomDialog>
  );
};

export default SDKDocsDialog;
